import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
import axios, { AxiosResponse } from 'axios';
import VueAxios from 'vue-axios';
// import jwt_decode from 'jwt-decode';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import 'vue-material-design-icons/styles.css';
import VModal from 'vue-js-modal';
// import moment from 'moment';
import vuetify from './plugins/vuetify';
import VueFullPage from 'vue-fullpage.js';
import { IRawDailyDataSumParam } from './interfaces';

import 'vue-material-design-icons/styles.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(vuetify, {
  iconfont: 'md',
});

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

export const BASE_BACKEND_URL = 'https://shimmyplus-default-backend.carnegosystems.net';
export const BASE_FRONTEND_URL = 'https://shimmyplus-default.carnegosystems.net';
export const BMOS_URL = 'https://bmos.carnegosystems.net';

const store = new Vuex.Store({
  state: {
    jwt: localStorage.getItem('shimmyplus_token'),
    endpoints: {
      obtainJWT: 'https://shimmyplus-default-backend.carnegosystems.net/rest/public/api-token-auth/',
      verifyJWT: 'https://shimmyplus-default-backend.carnegosystems.net/rest/public/validate_token/',
    },
    test: 'initial',
    bmos_ids: [],
    startDate: '',
    endDate: '',
    resolution: -1,
    aggregate: -1,
    datatype: -1,
    infos: {},
  },
  mutations: {
    updateToken(state, newToken) {

      localStorage.setItem('shimmyplus_token', newToken);
      console.log('updateToken: ' + newToken + '  ' + Date());
      // state.jwt = newToken;
      Vue.set(state, 'jwt', newToken);
      console.log('set token');
    },
    removeToken(state) {
      localStorage.removeItem('shimmyplus_token');
      Vue.set(state, 'jwt', null);
    },
    setTest(state, s) {
      state.test = s;
    },
    setBmosIds(state, ids: []) {
      state.bmos_ids = ids;
    },
    setStartDate(state, s) {
      state.startDate = s;
    },
    setEndDate(state, s) {
      state.endDate = s;
    },
    setResolution(state, val: number) {
      state.resolution = val;
    },
    setAggregate(state, val: number) {
      state.aggregate = val;
    },
    setDataType(state, val: number) {
      state.datatype = val;
    },
    updateInfo(state, infos: {}) {
      state.infos = infos;
    },
  },
  getters: {
    isAuthenticated(state) {
      console.log('in isAuthenticated');
      const token = localStorage.getItem('shimmyplus_token');
      const storeToken = state.jwt;
      return (token !== null && token !== undefined && (storeToken === token));
    },
    Jwt(state) { return state.jwt; },
    Test(state) { return state.test; },
    BmosIds(state) { return state.bmos_ids; },
    StartDate(state) { return state.startDate; },
    EndDate(state) { return state.endDate; },
    Infos(state) { return state.infos; },
    Resolution(state) { return state.resolution; },
    Aggregate(state) { return state.aggregate; },
    DataType(state) { return state.datatype; },
  },
  actions: {
    verifyToken(type, token: string) {

      const self = this;

      const headers = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Token ' + token,
        },
      };

      this.commit('removeToken');

      return axios.get(this.state.endpoints.verifyJWT, headers)
        .then((response) => {

          if (response.data !== undefined && response.data !== null && response.data['validated'] === 'true'
           && response.data['token']) {
            self.commit('updateToken', token);
            return true;
          }

          return false;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    obtainToken(type, payload: object) {

      const self = this;

      const headers = {
        headers: { 'Content-Type': 'application/json' },
      };

      this.commit('removeToken');

      return axios.post(this.state.endpoints.obtainJWT, payload, headers)
        .then((response) => {

          if (response.data !== undefined && response.data !== null && response.data['token']) {
            self.commit('updateToken', response.data.token);
            return true;
          }

          return false;
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response.data);
            return false;
          }
        });
    },
    getHouseMeterRawDailyDataSumBetweenDates(context, payload: IRawDailyDataSumParam) {

      const headers = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Token ' + this.state.jwt,
        },
      };

      const url = 'https://shimmynew.carnegosystems.net/crucible/crucible/house_meter_raw_daily_data_sum_between_dates/'
                    + payload.startDate.format('YYYY-MM-DD') + '/'
                    + payload.endDate.format('YYYY-MM-DD') + '/' + payload.meterType;

      return axios.get(url, headers)
        .then((response) => {
          return true;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    setTest(context, s: string) {
      context.commit('setTest', s);
    },
    setBmosIds(context, ids: []) {
      context.commit('setBmosIds', ids);
    },
    setAggregate(context, aggregate: number) {
      context.commit('setAggregate', aggregate);
    },
    setResolution(context, resolution: number) {
      context.commit('setResolution', resolution);
    },
    setStartDate(context, startDate: string) {

      context.commit('setStartDate', startDate);
    },
    setEndDate(context, endDate: string) {

      context.commit('setEndDate', endDate);
    },
  },
});

Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: false } });

Vue.use(VueFullPage);

export default store;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
